/* ============
 * Product Group Transformer
 * ============
 *
 * The transformer for the product group.
 */

import Transformer from './transformer';

export default class MarketplaceProductTransformer extends Transformer {

  static fetch(marketplaceProduct) {
    return {
      name: marketplaceProduct.name,
      productId: marketplaceProduct.product_id,
      productTypeId: marketplaceProduct.product_type_id,
      price: marketplaceProduct.price,
      containsAlcohol: marketplaceProduct.contains_alcohol,
      image: marketplaceProduct.image ? { url: marketplaceProduct.image } : undefined,
      status: marketplaceProduct.status,
      shortDescription: marketplaceProduct.short_description,
      longDescription: marketplaceProduct.long_description,
      approvedAt: marketplaceProduct.approved_at,
    };
  }

  static send(marketplaceProduct) {
    return {
      name: marketplaceProduct.name,
      product_id: marketplaceProduct.productId,
      product_type_id: marketplaceProduct.productTypeId,
      image: marketplaceProduct.image && marketplaceProduct.image.file ? marketplaceProduct.image.file : '',
      price: marketplaceProduct.price,
      status: marketplaceProduct.status,
      short_description: marketplaceProduct.shortDescription,
      long_description: marketplaceProduct.longDescription,
      approved_at: marketplaceProduct.approvedAt,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/marketplaceProduct.js